import { render } from "./SelectServices.vue?vue&type=template&id=273f168f"
import script from "./SelectServices.vue?vue&type=script&lang=js"
export * from "./SelectServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__